import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Avatar from '@atlaskit/avatar';
import Lozenge from '@atlaskit/lozenge';
import { N30 } from '@atlaskit/theme/colors';
import React from 'react';
import { isRestricted } from '../../types';
import { NoAccessLabel } from '../../util/i18n';
import { leftClick } from '../../util/mouse';
import AsyncNoAccessTooltip from '../NoAccessTooltip';
import AsyncLockCircleIcon from '../LockCircleIcon';
import { AccessSectionStyle, AvatarStyle, FullNameStyle, InfoSectionStyle, MentionItemStyle, NameSectionStyle, RowStyle, TimeStyle } from './styles';
import { renderHighlight } from './MentionHighlightHelpers';
import MentionDescriptionByline from '../MentionDescriptionByline';
import MessagesIntlProvider from '../MessagesIntlProvider';
export { MENTION_ITEM_HEIGHT } from './styles';
function renderLozenge(lozenge) {
  if (typeof lozenge === 'string') {
    return /*#__PURE__*/React.createElement(Lozenge, null, lozenge);
  }
  if (_typeof(lozenge) === 'object') {
    var appearance = lozenge.appearance,
      text = lozenge.text;
    return /*#__PURE__*/React.createElement(Lozenge, {
      appearance: appearance
    }, text);
  }
  return null;
}
function renderTime(time) {
  if (time) {
    return /*#__PURE__*/React.createElement(TimeStyle, null, time);
  }
  return null;
}
var MentionItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MentionItem, _React$PureComponent);
  var _super = _createSuper(MentionItem);
  function MentionItem() {
    var _this;
    _classCallCheck(this, MentionItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onMentionSelected", function (event) {
      if (leftClick(event) && _this.props.onSelection) {
        event.preventDefault();
        _this.props.onSelection(_this.props.mention, event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMentionMenuItemMouseMove", function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(_this.props.mention, event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMentionMenuItemMouseEnter", function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(_this.props.mention, event);
      }
    });
    return _this;
  }
  _createClass(MentionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        mention = _this$props.mention,
        selected = _this$props.selected;
      var id = mention.id,
        highlight = mention.highlight,
        avatarUrl = mention.avatarUrl,
        presence = mention.presence,
        name = mention.name,
        mentionName = mention.mentionName,
        lozenge = mention.lozenge,
        accessLevel = mention.accessLevel;
      var _ref = presence || {},
        status = _ref.status,
        time = _ref.time;
      var restricted = isRestricted(accessLevel);
      var nameHighlights = highlight && highlight.name;
      var borderColor = selected ? "var(--ds-border, ".concat(N30, ")") : undefined;
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(MentionItemStyle, {
        selected: selected,
        onMouseDown: this.onMentionSelected,
        onMouseMove: this.onMentionMenuItemMouseMove,
        onMouseEnter: this.onMentionMenuItemMouseEnter,
        "data-mention-id": id,
        "data-mention-name": mentionName
      }, /*#__PURE__*/React.createElement(RowStyle, null, /*#__PURE__*/React.createElement(AvatarStyle, {
        restricted: restricted
      }, /*#__PURE__*/React.createElement(Avatar, {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor
      })), /*#__PURE__*/React.createElement(NameSectionStyle, {
        restricted: restricted
      }, renderHighlight(FullNameStyle, name, nameHighlights), /*#__PURE__*/React.createElement(MentionDescriptionByline, {
        mention: mention
      })), /*#__PURE__*/React.createElement(InfoSectionStyle, {
        restricted: restricted
      }, renderLozenge(lozenge), renderTime(time)), restricted ? /*#__PURE__*/React.createElement(React.Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(AsyncNoAccessTooltip, {
        name: name
      }, /*#__PURE__*/React.createElement(AccessSectionStyle, null, /*#__PURE__*/React.createElement(NoAccessLabel, null, function (text) {
        return /*#__PURE__*/React.createElement(AsyncLockCircleIcon, {
          label: text
        });
      } /* safe to cast to string given there is no value binding */)))) : null)));
    }
  }]);
  return MentionItem;
}(React.PureComponent);
export { MentionItem as default };